import { getIsoDateStringFromDate, loggerUtils } from '@color/lib';
import moment from 'moment-timezone';

import { LOCAL_TIMEZONE_NAME } from './constants';

/**
 * @deprecated Convert to `getIsoDateStringFromDate`.
 * Returns a date only string representation when given a Date object or string in `ISO-8601` format.
 * This is fairly uncontrolled, and also may have timezone offset issues.
 * See: https://getcolor.atlassian.net/browse/UXTASK-1483
 * Use for date events which have no timezone component, like birthdays.
 * This always returns an ISO-8601 Date-only string.
 * Example: 1969-04-20
 */
export const toIsoDate = (date: Date | string): string => {
  // TODO Refactor to remove moment - but be aware that moment uses global timezone. Simply switching to date-fns may break things.
  // Changing to date-fns breaks the tests due to time-zone.
  const momentString = moment(date).format('YYYY-MM-DD');
  if (typeof date === 'string') {
    loggerUtils.logMessage(new Error(`toIsoDate was called with a string: ${date}`));
  } else {
    const isoDateString = getIsoDateStringFromDate(date);

    // Temporary logging to ensure values are equivalent before switching over to date-fns-tz.
    if (momentString !== isoDateString) {
      loggerUtils.logMessage(
        new Error(
          `isoDateString format does not match moment format for ${date.toISOString()} in ${LOCAL_TIMEZONE_NAME}. Expected ${momentString}, received ${isoDateString}`
        )
      );
    }
  }

  return momentString;
};

/**
 * Returns a Date object when given a Date only string representation.
 * Example: 1969-04-20
 * Use for date events which have no timezone component, like birthdays.
 */
export const fromIsoDate = (dateOnlyString: string): Date => {
  // TODO Refactor to remove moment -  but be aware that moment uses global timezone. Simply switching to date-fns may break things.
  const momentDate = moment(dateOnlyString).toDate();
  return momentDate;
};

/**
 * Returns a Date object when given a Date time string representation.
 * Example: 1969-04-20T16:20:00.420Z
 */
export const fromIsoDateTime = (dateTimeString: string): Date => {
  return new Date(dateTimeString);
};
